import { resources } from '@api'
import Breadcrumps from '@blocks/Breadcrumps'
import MainContainer from '@blocks/MainContainer'
import { notify, route } from '@helpers'
import useAuth from '@hooks/useAuth'
import useStatic from '@hooks/useStatic'
import useTitle from '@hooks/useTitle'
import React from 'react'
import { unstable_batchedUpdates } from 'react-dom'
import { useHistory } from 'react-router-dom'
import ClubForm from './Form'

export default function ClubAdd({ club }: Props) {
    const auth = useAuth()

    const history = useHistory()
    useTitle("Group: Edit")

    const handleSuccess = (club: Resources.Club) => {
        unstable_batchedUpdates(() => {
            auth.set('club', club)
            auth.set('membership.club', club)
        })
        
        history.push(route("club:customer", club.id))
        notify("The group was successfully updated.")
    }

    const heading = useStatic(<Breadcrumps items={[
        { name: club.name, url: route("club:customer") }, 
        { name: "Edit" }
    ]} />)

    return (
        <MainContainer heading={heading}>
            <ClubForm 
                method="patch"
                action={`${resources.clubs}/${club.id}`}
                handleSuccess={handleSuccess}
                club={club} />
        </MainContainer>
    )
}

interface Props {
    club: Resources.Club
}